import { render, staticRenderFns } from "./PersonelDetayView.vue?vue&type=template&id=27b5cf3f"
import script from "./PersonelDetayView.vue?vue&type=script&lang=ts"
export * from "./PersonelDetayView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports